import { t } from 'i18next';
import { AppTableFilters } from 'services/AppTableFilters';

// types
import { createFilter } from "../../components/Tables/ColumnCreationHelper";

export const appTableFiltersInstance = new AppTableFilters();

export const OrganizationsTableColumns = () => [
  {
    id: 'id',
    Header: t('table.id'),
    accessor: 'id',
    maxWidth: 140,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'id', t('table.id'))
  },
  {
    id: 'name',
    Header: t('table.name'),
    accessor: 'name',
    maxWidth: 100,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'name',t('table.name'))
  },
  {
    id: 'shortName',
    Header: t('table.shortName'),
    accessor: 'shortName',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'shortName', t('table.shortName'))
  },
  {
    id: 'externalId',
    Header: t('table.externalId'),
    accessor: 'externalId',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'externalId', t('table.externalId'))
  },
  {
    id: 'links',
    Header: t('table.links'),
    accessor: 'links',
    maxWidth: 40,
  },
];
